import { render, staticRenderFns } from "./ClientSelection.vue?vue&type=template&id=1e7830b4&scoped=true&"
import script from "./ClientSelection.vue?vue&type=script&lang=js&"
export * from "./ClientSelection.vue?vue&type=script&lang=js&"
import style0 from "./ClientSelection.vue?vue&type=style&index=0&id=1e7830b4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1e7830b4",
  null
  
)

export default component.exports